export const OmnisendIcon = () => {
  return (
    <img
      width="32"
      height="32"
      src="/assets/logo-omnisend.png"
      alt="Omnisend email marketing"
    />
  );
};
